export default function CsharpMathMethods() {
  return (
    <h2>Csharp Math Methods</h2>
  );
}
